
const state = () => ({

    times:[],
})


const getters = {
    get_times(state) {
        return state.times;
    },
}

const mutations = {
    SET_TIMES(state,data){
        let localData = []
        let localTimes = state.times
        localData.push(data)
        console.log('salam');
        try {
            state.times = localData.concat(localTimes)
        }
        catch (e){
            console.log('ee', e);
        }
        console.log('log times :', state.times);
    },
    REMOVE_TABLE(state,index){
        state.times.splice(index,1)
    }
}

const actions = {
    async fetchTimes({ commit }, payload) {
        commit('SET_TIMES', payload);
    },

}




export  default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
